export const RouteNames = {
	ONBOARDING: {
		LOGIN: '/onboarding/loginOrRegister',
		INTRODUCTION: '/onboarding/introduction',
		LEGITIMATION: '/onboarding/legitimation',
		LEGITIMATION_PENDING: '/onboarding/legitimation/pending',
		LEGITIMATION_ABORTED: '/onboarding/legitimation/aborted',
		LEGITIMATION_FRAUD: '/onboarding/legitimation/fraud',
		ASSOCIATION_SELECTION: '/onboarding/associationSelection',
		ASSOCIATION_REGISTRATION: '/onboarding/associationRegistration',
		ASSOCIATION_BOARDMEMBERSHIP: {
			CREATE: '/onboarding/associationBoardMembership/create',
			UPDATE: '/onboarding/associationBoardMembership/update',
		},
	},
	HOME: {
		DASHBOARD: '/home/dashboard',
		ACCOUNT: '/home/account',
		MEMBERS: '/home/members',
	},
	INDEX: '/home/dashboard',
}
